// extracted by mini-css-extract-plugin
export default {"container":"Services_container__fYNA3","cards":"Services_cards__jbCBI"};